export default "__VITE_ASSET__Cp79mu9I__"